import { jsxs as r, jsx as o } from "react/jsx-runtime";
const n = (e) => /* @__PURE__ */ r("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: [
  /* @__PURE__ */ o("path", { d: "M19 19L5 5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M5 19L19 5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })
] });
export {
  n as default
};
//# sourceMappingURL=close.js.map
